import {createApiResource} from 'data/utils';
import {userInclude as userMeInclude} from 'modules/common/constants';
import {useQuery} from '@tanstack/react-query';
import {useApi} from 'hooks/api/useApi';
import {useAuth} from 'hooks/useAuth';
import * as normalize from 'utils/normalize';

const resource = createApiResource({
	name: 'user',
	pathName: '/users',
	unwrap: x => x,
	cascadeTo: ['userOptions'],
});

export const userQueryClientHelpers = resource.createQueryClientHelpers();

export const useUsers = resource.createUseQueryIndex();
export const useUser = resource.createUseQueryById();

export const useUserMe = ({useQueryOptions = {}} = {}) => {
	const {get} = useApi();
	const params = resource.mergeDefaultParams({
		include: userMeInclude.include.split(','),
	});

	return useQuery({
		queryKey: resource.getQueryKey('me'),
		queryFn: () =>
			get(resource.getResourcePath('me'), {params}).then(({data}) =>
				normalize.user(data),
			),
		keepPreviousData: true,
		...useQueryOptions,
	});
};

const useOnSettledUserUpdate = ({id}, {queryClient}) => {
	const {user} = useAuth();
	if (id === user.id) {
		userQueryClientHelpers.invalidateCustom(queryClient, 'me');
	}
};

export const useCreateUser = resource.createUseMutationCreate();
export const useUpdateUser = resource.createUseMutationUpdate({
	onSettled: useOnSettledUserUpdate,
});

const useOnMutateUserDelete = ({id}) => {
	const {user} = useAuth();
	if (id === user.id) {
		throw new Error('Cannot delete current user');
	}
};

export const useDeleteUser = resource.createUseMutationDelete({
	onMutate: useOnMutateUserDelete,
	onSettled: useOnSettledUserUpdate,
});
